import { createStore } from 'satcheljs';
import { ReadingPaneStore } from './schema/ReadingPaneState';
import '../mutators/showSchedulingAssistantMutator';

let readingPaneStoreData: ReadingPaneStore = {
    viewState: null,
};

export const getStore = createStore<ReadingPaneStore>(
    'calendarReadingPaneStore',
    readingPaneStoreData
);
export default getStore();
